<template>
  <div
    class="landingContentIconsBannerSection"
    :style="`background-color: ${data.BackgroundColor}`"
  >
    <div class="container">
      <div class="landingContentIconsBannerSection__content">
        <div
          class="landingContentIconsBannerSection__col landingContentIconsBannerSection__col--right"
        >
          <div
            v-if="data.Icons && data.Icons.length"
            class="landingContentIconsBannerSection__icons"
          >
            <div
              v-for="(icon, index) in data.Icons"
              :key="index"
              class="landingContentIconsBannerSection__box"
            >
              <div v-if="icon.Icon" class="landingContentIconsBannerSection__boxImage">
                <new-image-box
                  :alt="icon.Title ? data.Title : ''"
                  :src="JSON.parse(icon.Icon).url"
                  :width="150"
                  :height="150"
                  center-image
                  image-params="w_150,h_150,crop"
                />
              </div>
              <div class="landingContentIconsBannerSection__boxTitle">{{ icon.Title }}</div>
              <div class="landingContentIconsBannerSection__boxDesc">{{ icon.Description }}</div>
            </div>
          </div>
          <div class="landingContentIconsBannerSection__word">
            <img v-if="data.Background" :src="JSON.parse(data.Background).url" />
          </div>
        </div>
        <div class="landingContentIconsBannerSection__col">
          <div
            class="landingContentIconsBannerSection__text"
            v-if="data.Description"
            v-html="data.Description"
          ></div>
          <VButton
            v-if="data.Button.Url && data.Button.LinkText"
            class="landingContentIconsBannerSection__button"
            :text="data.Button.LinkText"
            :href="data.Button.Url"
            theme="orange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VButton from '@/components/VButton.vue';
import NewImageBox from '@/components/NewImageBox.vue';

export default {
  name: 'LandingContentIconsBannerSection',
  components: { NewImageBox, VButton },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
.landingContentIconsBannerSection {
  padding: 10rem 0 17rem;
  background: $cMain;

  @include rwd('laptop') {
    padding: 7rem 0 14rem;
  }

  @include rwd('tablet') {
    padding: 4rem 0;
  }

  &__content {
    display: flex;
    flex-direction: row-reverse;

    @include rwd('tablet') {
      flex-direction: column;
    }
  }

  &__text {
    color: $cWhite;
  }

  &__col {
    flex: 1;

    &--right {
      position: relative;
      padding-left: 7rem;
      min-width: 64rem;
      height: 100%;

      @include rwd('small-laptop') {
        min-width: 50rem;
        padding-left: 4rem;
      }

      @include rwd('tablet') {
        min-width: unset;
        padding-left: 0;
        margin-bottom: 4rem;
      }
    }
  }

  &__word {
    position: absolute;
    right: 89%;
    bottom: 0;

    img {
      max-width: 30rem;
      transform: translateY(95%);
    }

    @include rwd('laptop') {
      transform: translateY(20%);
      right: 35%;
    }

    @include rwd('tablet') {
      position: relative;
      text-align: center;
      right: unset;

      img {
        transform: none;
      }
    }
  }

  ::v-deep p,
  ::v-deep li {
    font-size: 1.6rem;
    line-height: 2.4rem;
    font-weight: 500;

    b,
    strong {
      font-weight: 700;
    }
  }

  ::v-deep p {
    margin-bottom: 2rem;
  }

  ::v-deep li {
    position: relative;
    margin-bottom: 1.4rem;
    padding-left: 3rem;

    &:after {
      @include icomoon('circle-fill-check');
      position: absolute;
      left: 0;
      top: 0;
      color: $cSec;
    }
    &:before {
      content: '';
      width: 1rem;
      height: 1rem;
      background: $cWhite;
      position: absolute;
      border-radius: 50%;
      left: 0.3rem;
      top: 0.6rem;
      color: $cSec;
    }
  }

  ::v-deep h1,
  ::v-deep h2,
  ::v-deep h3,
  ::v-deep h4,
  ::v-deep h5 {
    font-size: 4.8rem;
    line-height: 1.1;
    font-weight: 500;
    margin-bottom: 2rem;

    b,
    strong {
      color: $cSec;
      font-weight: 600;
    }

    @include rwd('large-tablet') {
      font-size: 4rem;
    }

    @include rwd('tablet') {
      max-width: 100%;
    }

    @include rwd('small-tablet') {
      font-size: 2.8rem;
    }
  }

  &__button {
    min-width: 28.5rem;

    @include rwd('tablet') {
      min-width: 100%;
    }
  }

  &__icons {
    display: flex;
    background-color: $cWhite;
    border-radius: 10px;
    padding: 2.5rem;

    @include rwd('small-laptop') {
      padding: 1rem;
    }
  }

  &__box {
    flex: 0 0 33.333%;
    max-width: 33.333%;
    padding: 0 2.5rem;
    text-align: center;

    @include rwd('small-laptop') {
      padding: 0 1rem;
    }
  }

  &__boxImage {
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $cWhite;
    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.2)) drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.08));
    margin-bottom: 1rem;
    padding: 2rem;
  }

  &__boxTitle {
    font-size: 1.7rem;
    line-height: 1.3;

    @include rwd('small-tablet') {
      font-size: 1rem;
    }
  }

  &__boxDesc {
    color: rgba(52, 55, 66, 1);
    font-size: 1.4rem;
    line-height: 2rem;

    @include rwd('small-tablet') {
      font-size: 1rem;
    }
  }
}
</style>
